export default {
  logout: () => '/logout',
  login: () => '/login',
  projects: () => '/',
  projectDetails: (projectId) => `/project/${projectId}`,
  projectEditor: (projectId) => `/project/${projectId}/edit`,
  rateProject: (projectId) => `/project/${projectId}/rate`,
  allDocuments: () => '/documents',
  profile: () => '/profile',
  linkedAccounts: () => '/linked-accounts',
  coupons: () => '/coupons',
  referAFriend: () => '/refer',
  newProject: () => '/new',
  billing: () => '/billing'
}



// WEBPACK FOOTER //
// ./src/client/misc/links.js